export type ArrowRightIconProps = {
  width: string | number;
  height: string | number;
};

const ArrowRightIcon = ({ width, height }: ArrowRightIconProps) => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 12H19.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 5L19.5 12L12.5 19"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export default ArrowRightIcon;
